<template>
  <div id="map-relic-header" class="map-relic-header">
    <div class="map-relic-header-left">
      <img
        class="header-img"
        :src="
          mapRelicDetail.relicEditPageInfoDTO.coverUrl ||
            'http://point-cloud-write.oss-cn-shenzhen.aliyuncs.com/img/2_404.png'
        "
        alt=""
      />
      <div class="left-add font-h3">
        <div
          class="left-add-content"
          @click="handleShowAdd"
          v-if="authToken && inspectorLimit"
        >
          <img src="../../assets/images/normal_add.svg" alt="" />
          <span>添加巡查记录</span>
        </div>
        <div class="left-add-info">
          <div class="left-add-info_name">
            {{ mapRelicDetail.relicEditPageInfoDTO.relicName }}
          </div>
          <div class="left-add-info_level">
            建筑编号：{{ mapRelicDetail.relicEditPageInfoDTO.relicFromUserId }}
          </div>
        </div>
      </div>
    </div>
    <div class="map-relic-header-right" v-if="!isMobile">
      <ul class="right-list" v-if="!transformContrl">
        <li v-for="(item, index) in baseInfo" :key="index">
          <div class="item-type">{{ item.label }}：</div>
          <div class="item-text">{{ item.value }}</div>
        </li>
      </ul>
    </div>
    <img
      v-show="!isMobile"
      @click="handleZhanKai"
      class="map_zhankai"
      src="../../assets/images/map_zhankai.svg"
      alt=""
    />
    <report-found
      v-model="saveCtrlParam"
      v-bind:reportDetail.sync="reportDetail"
      @onSaveAllClick="handleConfirmAddReport"
    />
    <file-uploader-ctrl ref="uploader" :filePath="filePath" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import {
  searchNewestInspectreport,
  addInspectreport,
  updateReportPhotoList
} from '../../api';
import FileUploaderCtrl from '../layout/file-uploader-ctrl.vue';
import ReportFound from '../report/report-found.vue';
export default {
  components: { ReportFound, FileUploaderCtrl },
  props: {
    mapRelicDetail: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters('login', [
      'authorizationLimit',
      'userInfo',
      'authToken',
      'isMobile'
    ]),
    filePath() {
      return `relic/${this.mapRelicDetail.relicEditPageInfoDTO.relicAutoIncrementId}/report`;
    },
    baseInfo() {
      return [
        {
          label: '建筑类型',
          value: this.mapRelicDetail.relicEditPageInfoDTO.relicTypeEnum
        },
        {
          label: '建筑年代',
          value: this.mapRelicDetail.relicEditPageInfoDTO.relicAge
        },
        {
          label: '建筑地址',
          value: this.mapRelicDetail.relicEditPageInfoDTO.relicAddress
        }
      ];
    }
  },
  data() {
    return {
      inspectorLimit: false,
      visibleReportSetUpDialog: false,
      reportDetail: {},
      transformContrl: false,
      saveCtrlParam: {
        visibleAddDialog: false, //是否显示弹窗
        active: 0, //控制组件活动
        visibleEdit: false, //是否可编辑
        visibleCreate: false //是否是创建模式
      }
    };
  },
  mounted() {
    this.inspectorLimit = this.authorizationLimit.some(e => {
      return e == 4;
    });
  },
  methods: {
    ...mapMutations('report', ['setCreateType', 'setReportDetail']),
    /**
     * 展开详情
     */
    handleZhanKai() {
      const zhanKaiImg = document.querySelector('.map_zhankai');
      if (!this.transformContrl) {
        zhanKaiImg.style.transform = 'rotate(180deg)';
        this.transformContrl = true;
        this.$emit('onZhanKai', this.transformContrl);
      } else {
        zhanKaiImg.style.transform = 'rotate(360deg)';
        this.transformContrl = false;
        this.$emit('onZhanKai', this.transformContrl);
      }
    },
    /**
     * 显示添加
     */
    async handleShowAdd() {
      const {
        relicEditPageInfoDTO: { relicAutoIncrementId, relicAddress }
      } = this.mapRelicDetail;
      const {
        data: { data }
      } = await searchNewestInspectreport(relicAutoIncrementId);

      if (data) {
        this.reportDetail = Object.assign({}, data, {
          inspectorNickName: this.userInfo.nickName,
          inspectorUid: this.userInfo.uid,
          photos: [],
          createTime: '',
          updateTime: '',
          relicAutoIncrementId,
          relicAddress,
          inspectMessage: ''
        });
      } else {
        const reportTemplate = {
          agent: '',
          agentContact: '',
          brandStatusEnum: '',
          buildingDamageStatusEnum: '',
          constructingComponentEnums: [],
          createTime: '',
          facadeStatusEnum: '',
          finished: '',
          inspectMessage: '',
          inspectReportId: '',
          inspectStatusEnum: '',
          inspectTypeEnum: '',
          inspectorNickName: '',
          inspectorUid: '',
          otherConstructingComponents: '',
          otherSituationEnums: [],
          owner: '',
          ownerContact: '',
          relicAddress,
          relicAutoIncrementId,
          relicDirectorEnum: '',
          relicDistrictEnum: '',
          relicFromUserId: '',
          relicName: '',
          updateTime: '',
          user: '',
          userContact: ''
        };
        this.reportDetail = Object.assign({}, reportTemplate, {
          inspectorNickName: this.userInfo.nickName,
          inspectorUid: this.userInfo.uid,
          photos: []
        });
      }
      this.saveCtrlParam.visibleEdit = true;
      this.saveCtrlParam.visibleAddDialog = true;
      this.saveCtrlParam.visibleCreate = true;
      this.saveCtrlParam.active = 0;
    },
    /**
     * 上传照片回调
     * @param {Array} params 照片数组
     */
    async handleUploadPhoto(params) {
      let oldArray = params.filter(item => !item.file);
      let newArray = params.filter(item => item.file);
      if (newArray.length > 0) {
        const result = await this.$refs.uploader.uploadFileParams(newArray);

        newArray = result.map(item => {
          const {
            value: { param, url }
          } = item;
          delete param.file;
          param.url = url;
          param.thumb = url;
          return param;
        });
      }
      return [...oldArray, ...newArray];
    },

    /**
     * 确认添加巡查报告
     */
    async handleConfirmAddReport() {
      const baseInfo = Object.assign({}, this.reportDetail);
      const imglist = this.reportDetail.photos;
      delete baseInfo.photos;
      const {
        data: { data: inspectReportId }
      } = await addInspectreport(baseInfo);
      //
      const photoUpdateQueryList = await this.handleUploadPhoto(imglist);
      if (photoUpdateQueryList.length > 0)
        await updateReportPhotoList({ photoUpdateQueryList, inspectReportId });
      this.saveCtrlParam.visibleAddDialog = false;
      this.$emit('onRefreshReport');
      // this.saveCtrlParam.visibleAddDialog = false;
      this.$prompt('创建成功');
    }
  }
};
</script>

<style lang="scss">
.map-relic-header {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  padding: 15px 0px;
  max-height: 246px;
  overflow: hidden;
  &-left {
    flex: 1;
    display: flex;
    // justify-content: space-around;
    .left-add {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 50px;
      padding: 10px 0;
      height: 240px;
      &-content {
        color: $color-primary;
        img {
          width: 22px;
          height: 22px;
        }
      }
      &-info {
        &_name {
          font-size: 22px;
          padding-bottom: 18px;
        }
        &_level {
          color: #aaa;
        }
      }
    }
    .header-img {
      width: 240px;
      height: 240px;
    }
  }
  &-right {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    .right-list {
      width: 270px;
      li {
        margin: 5px 0;
        div {
          padding: 5px 0;
          font-size: 14px;
        }
        .item-type {
          color: #888;
          letter-spacing: 0.5em;
        }
      }
    }
  }
  .map_zhankai {
    position: absolute;
    width: 22px;
    height: 22px;
    right: 20px;
    top: 246px;
    z-index: 400;
  }
}
@media screen and (max-width: 750px) {
  .map-relic-header {
    max-height: 360px;
    display: block;
    &-left {
      display: block;
      .left {
        &-add {
          display: block;
          position: relative;
          margin-left: 0px;
          &-content {
            position: absolute;
            top: 77px;
          }
        }
      }
    }
  }
}
</style>
